import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAuto } from "../../../core/Helper";

export default function BrchPopup({ props }) {
  const [company, setCompany] = useState([]);

  // show company for selected
  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API + "api/company/selected-list",
        {},
        HttpJsonHeader
      )
      .then((res) => {
        setCompany(res.data.lists);
      })
      .catch((err) => alert(err));
  }, []);

  let rowId = props.fields == null ? -1 : props.fields.brchid;
  // let pvCmpId = props.fields==null? -1: props.fields.compid;

  const submit = (evt) => {
    let data = {
      BrchId: rowId,
      BrchCode: evt.target.oBrchCode.value,
      BrchName: evt.target.oBrchName.value,
      CompId: evt.target.oCompId.value,
      BrchAddr1: evt.target.oBrchAddr1.value,
      BrchAddr2: evt.target.oBrchAddr2.value,
      Phone: evt.target.oPhone.value,
      Email: evt.target.oEmail.value,
      updateby: props.user.userid,
    };

    if (rowId < 0) {
      data = { ...data, createby: props.user.userid };
    }

    evt.preventDefault();
    axios
      .post(
        process.env.REACT_APP_API + "api/branch/update",
        data,
        HttpJsonHeader
      )
      .then((res) => {
        props.setUpdate(true);
        props.hidePopup();
      })
      .catch((err) => console.log(err));
  };

  const FIELDS = [
    {
      label: "รหัส",
      oName: "oBrchCode",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.brchcode,
      type: "text",
    },
    {
      label: "ชื่อสาขา",
      oName: "oBrchName",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.brchname,
      type: "text",
    },
    {
      label: "ที่อยู่",
      oName: "oBrchAddr1",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.brchaddr1,
      type: "text",
    },
    {
      label: "",
      oName: "oBrchAddr2",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.brchaddr2,
      type: "text",
    },
    {
      label: "โทรศัพท์",
      oName: "oPhone",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.phone,
      type: "text",
    },
    {
      label: "เมล์",
      oName: "oEmail",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.email,
      type: "text",
    },
    {
      label: "บริษัท",
      oName: "oCompId",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.compid,
      type: "select",
      rows: company,
    },
  ];

  return (
    <MyModal show={props.show} size="lg" onHide={props.hidePopup}>
      <ModalHeaderBlack closeButton>
        {" "}
        เพิ่มแก้ไข {props.formName}{" "}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        <FormAuto {...{ formId: "form1", items: FIELDS, submit: submit }} />
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" type="submit" form="form1">
          Save changes
        </Button>
        <Button variant="danger" onClick={props.hidePopup}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
